import {
  LANDING_ASSETS,
  LANDING_HERO_TYPOGRAPHY,
} from "../constants/landing.constants";
import { LANDING_HERO } from "../data/landing.mock";
import LandingIcon from "./LandingIcon";

export default function HeroCarousel() {
  return (
    <section className="landing-hero">
      <img
        src={LANDING_ASSETS.heroBanner}
        alt=""
        className="pointer-events-none absolute inset-0 h-full w-full object-cover object-[75%_center] md:object-center"
        aria-hidden
      />

      <div className="relative z-10 h-full w-full">
        <div
          className={`landing-hero-badge ${LANDING_HERO_TYPOGRAPHY.badgeWrapper}`}
        >
          <span className={LANDING_HERO_TYPOGRAPHY.badge}>
            <LandingIcon
              name="starRounded"
              className={LANDING_HERO_TYPOGRAPHY.badgeIcon}
            />
            <span className="min-w-0">{LANDING_HERO.badge}</span>
          </span>
        </div>

        <div
          className={`landing-hero-content ${LANDING_HERO_TYPOGRAPHY.content}`}
        >
          <h1 className={LANDING_HERO_TYPOGRAPHY.title}>
            <span className="md:hidden">
              {LANDING_HERO.titleMobileLines[0]}
              <br />
              {LANDING_HERO.titleMobileLines[1]}
            </span>
            <span className="hidden md:inline">{LANDING_HERO.title}</span>
          </h1>
          <p className={LANDING_HERO_TYPOGRAPHY.subtitle}>
            {LANDING_HERO.subtitle}
          </p>
        </div>
      </div>
    </section>
  );
}
